import { render } from "./HeroiconsSolidArrowNarrowRight.vue?vue&type=template&id=bbae033c"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowNarrowRight.vue"]])

export default __exports__